import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoginComponent } from "./pages/login/login.component";

import { AuthRoutingModule } from "./auth.routing";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DxButtonModule, DxSelectBoxModule } from "devextreme-angular";
import { NgxLoadingModule } from "ngx-loading";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { DxSharedModule } from "@app/shared/dx-shared.module";
import { IconEyeComponent } from "@app/shared/ui/icons/icon-eye.component";
import { IconCrossEyeComponent } from "@app/shared/ui/icons/icon-cross-eye.component";
import { IconErrorComponent } from "@app/shared/ui/icons/icon-error.component";
import { AuthLayoutLogo } from "@app/modules/auth/components/auth-layout-logo/auth-layout-logo.component";
import { LoginNewComponent } from "@app/modules/auth/pages/login-new/login-new.component";

@NgModule({
  declarations: [LoginComponent, LoginNewComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxSharedModule,
    NgxLoadingModule,
    FontAwesomeModule,
    TranslateModule,
    IconEyeComponent,
    IconCrossEyeComponent,
    IconErrorComponent,
    AuthLayoutLogo,
  ],
  exports: [LoginNewComponent],
})
export class AuthModule {}
